export const AUTOCOMPLETE_TEST_IDS = {
  root: 'autocomplete-root',
  input: 'autocomplete-input',
  option: 'autocomplete-option',
  listbox: 'autocomplete-listbox',
  popper: 'autocomplete-popper',
  clearButton: 'autocomplete-clear-button'
}

export const OPTIONS_RESET_UPPER_LIMIT = 256
export const LOAD_MORE_DATA_SCROLL_OFFSET = 2
